import { RESERVATIONS, SURVEYS, TAGS, State, BOOKER, PERSON } from "./state";
import { formatTime, isOptionOther } from '@/utils';
import { SelectLabelOptions, SelectOption } from "@/types/common";
import { Surveys, SurveySetQuestion } from "@/types/Surveys";

import moment from 'moment';

export const GET_RESERVATIONS_BY_TIME = 'getReservationsByTime';
export const GET_RESERVATIONS_SORTED = 'getReservationsSorted';
export const GET_SURVEY_OPTIONS = 'getSurveyOptions';
export const GET_TAG_OPTIONS = 'getTagOptions';
export const IS_BOOKER = 'isBooker';


export default {
  [IS_BOOKER]: (state: State): boolean => {
  return state[PERSON]?.id === state[BOOKER]?.Person?.id;
  },
  [GET_RESERVATIONS_BY_TIME]: (state: State) => {

    var start_time = moment().subtract(1,'hours');
    var end_time = moment().add(1,'hours');

    console.log('start time was '+start_time);
    console.log('end time was '+end_time);


    const reservations = state[RESERVATIONS]?.reduce((acc, reservation) => {
      const { reservation_for } = reservation;
      // check if reservation_for's time is outside the [start_time, end_time] range and if so, return acc


        var formated_reservation_for = moment(reservation_for);
        console.log('formated reservation for time '+formated_reservation_for);

        if(moment(formated_reservation_for).isBefore(start_time) || moment(formated_reservation_for).isAfter(end_time)){
          console.log('before/after reservation');
          return acc;
        }
        else{
          console.log("reservation before start? " + moment(formated_reservation_for).isBefore(start_time) );
          console.log("reservation after end?" + moment(formated_reservation_for).isAfter(end_time))
          console.log('need to display reservation time of bookers');
      }
      
      const timeKey = formatTime(reservation_for, 'hh:mm A');
      if (!acc[timeKey]) acc[timeKey] = [];
      acc[timeKey].push(reservation);
      
      acc[timeKey].sort((a: any, b: any) => (a.Booker.Person.first_name < b.Booker.Person.first_name) ? -1 : 0)
      return acc;
    }, {});

    return reservations
  },

  [GET_RESERVATIONS_SORTED]: (state: State) => {
    const unsorted = state[RESERVATIONS] ?? []
    return unsorted.length
      ? [...unsorted].sort((a: any, b: any) => a.Booker?.Person?.first_name?.trim().toLowerCase() < b.Booker?.Person?.first_name?.trim().toLowerCase() ? -1 : 0)
      : unsorted
  },

  // For each of the surveys, transform into { label: (question), options: [ (answer as { text: (answer text), value: (answer.id) } with any 'other' option placed last ) ]}
  [GET_SURVEY_OPTIONS]: (state: State) => {
    if (!state[SURVEYS]) return;

    // const BLACKLIST_CONFIG = JSON.parse(process.env.VUE_APP_SURVEY_BLACKLIST);
    // const CUSTOM_SORT_CONFIG = JSON.parse(process.env.VUE_APP_SURVEY_CUSTOM_SORT);
    const { Survey_set_questions } = state[SURVEYS] as Surveys;
    
    const surveyOpts = Survey_set_questions.reduce((acc, { id: surveyId, Survey_question, Survey_set_question_answer_options }: SurveySetQuestion) => {
      let customOrderItems = [] as [number, SelectOption][];
      let lastItems: SelectOption[] = []

      Survey_set_question_answer_options.sort((a, b) => {return a.Survey_answer_option.answers_order - b.Survey_answer_option.answers_order});

      const simplifiedAndOrderedAnswers: SelectOption[] = Survey_set_question_answer_options.reduce((acc, { survey_answer_option_id: answerId, Survey_answer_option }) => {
        if (Survey_answer_option.deleted == 1 || Survey_answer_option.answers_order < 1) return acc;

        const formatted: SelectOption = {
          text: Survey_answer_option.answer,
          value: answerId,
        }
        return [ ...acc, formatted ];
      }, [] as SelectOption[]);

      if (!acc[surveyId]) acc[surveyId] = {} as SelectLabelOptions<SelectOption>;

      const options = customOrderItems
        .sort((a: any, b: any) => a[0] < b[0] ? 0 : -1)
        .reduce((acc, [idx, opt]: [number | string, SelectOption]) => {
          acc.splice(idx as number, 0, opt)
          return acc
        }, simplifiedAndOrderedAnswers)

      return {
        ...acc,
        [surveyId as number]: {
          question_id: Survey_question?.id,
          label: Survey_question?.question,
          options: [...options, ...lastItems],
          // deleted: Survey_question?.deleted
        },
      }
    }, {} as Record<number, SelectLabelOptions<SelectOption>>);

    return surveyOpts
  },

  [GET_TAG_OPTIONS]: (state: State) => {
    const BLACKLIST = (process.env.VUE_APP_TAGS_BLACKLIST ?? '8,10,11,12,13').split(',');
    // NOTE: reformat tags to be just { text, value }
    if (!state[TAGS]) return [];
    return state[TAGS]?.reduce((acc, { id, name }) => ([ ...acc, { text: name, value: id } as SelectOption ]), [] as SelectOption[]);
  }
}